<template>
  <div class="d-flex justify-content-center container video-container">
    <video class="col-10" :src="require(`../assets/` + this.source)" controls :poster="require('../assets/'+this.thumbnail)"></video>
  </div>
</template>

<script>
export default {
name: "ProjectOverviewVideo",
  props:{
    source:{
      type: String,
      default: "../assets/mainpage/VideoTest.mp4"
    },
    thumbnail:{
      type: String,
      default: "hc3p/HC3P_BannerCropped.jpg"
    }
  }
}
</script>

<style lang="scss" scoped>

@import "~bootstrap/scss/functions";
@import "~bootstrap/scss/variables";
@import "~bootstrap/scss/mixins";

  .video-container{
    margin-top: 50px;
    margin-bottom: 50px;

    @include media-breakpoint-up(md) {
      margin-top: 100px;
      margin-bottom: 100px;
    }
  }

  video{
    padding: 0px;
    margin: 0 auto;
    //outline: 10px double #3e3e3e;
    box-shadow: 5px 5px 8px 5px rgba(0, 0, 0, 0.5);
  }
</style>